/**
 * @description Request Header ApplicationId 參數用
 */
export enum ApplicationId {
  FrontEnd='WWU-WEB',
  BackEnd = 'WWU-BOW'
}
